import { useAtom } from "jotai/index";
import { memo } from "react";
import { canv } from "@/canv/global";
import { penToolMenuColorAtom } from "@/interface/AppStore";
import { SelectableItem } from "@/interface/SideBar/PenMenu/SelectableItem";
import { PENT_TOOL_COLOR } from "@/tools/PenTool/constants";
import styles from "./PenMenu.module.css";

export const PenColorSelector = memo(() => {
    const [currentColor, setCurrentColor] = useAtom(penToolMenuColorAtom);
    const penTool = canv.toolBox.TryGetToolByName("penTool");
    const handleClick = (color: string) => {
        setCurrentColor(color);
        penTool?.setColor(color);
    };

    return (
        <div className={styles.penToolSubMenuColors}>
            {PENT_TOOL_COLOR.map((color) => (
                <SelectableItem
                    key={color}
                    isSelected={currentColor === color}
                    onClick={() => handleClick(color)}
                    className={styles.penToolSubMenuColorsItem}
                    selectedClassName={styles.penToolSubMenuTopItemSelected}
                >
                    <div
                        className={styles.penToolSubMenuColorsItemInner}
                        style={{ backgroundColor: color }}
                    />
                </SelectableItem>
            ))}
        </div>
    );
});
